import {
    call,
    select
} from 'redux-saga/effects';

import {
    debug
} from '../utils/logger';

import {
    makeRequest
} from '../sagas/makeRequest';

import { getManualEmailRoute } from '../utils/apiRoutes';

export function* genericEmailServiceSaga(formData, formSlug) {
    debug('Saga: genericEmailServiceSaga initialized');

    const state = yield select();
    const formConfig = state.core.featureConfigs ? state.core.featureConfigs[formSlug] : null;
    const path = getManualEmailRoute(formConfig.brandCode, _.get(formConfig, 'campaignId', ''));
    const payload = formatPayload(formData);

    let email = formConfig ? formConfig.sendToEmail : '';
    const homeStylistEmail = formConfig ? formConfig.homeStylistEmail : '';

    const isPersonalShopperPage = _.get(state.help, 'slug') === 'personal-styling-book-appointment';

    const hasPersonalShopperEmail = _.get(state.core.genericEmailService, 'stylistEmail');
    const hasPersonalShopperStoreEmail = _.get(state.core.genericEmailService, 'storeEmail');
    const hasHomeStylistEmail = _.get(state.core.genericEmailService, 'homeStylistEmail');

    const inStoreAppointment = _.get(state.core.genericEmailService, 'personalStylistLocation') === 'Instore';
    const isHomeAppointment = _.get(state.core.genericEmailService, 'appointmentType') === 'designCenter';

    if (isPersonalShopperPage) {

        if (isHomeAppointment) {

            if (inStoreAppointment && hasHomeStylistEmail) {
                email = hasHomeStylistEmail;
            } else {
                // For Home appointments - phone, email
                email = homeStylistEmail;
            }

        } else if (inStoreAppointment) {

            if (hasPersonalShopperEmail) {
                email = hasPersonalShopperEmail;
            } else if (hasPersonalShopperStoreEmail) {
                email = hasPersonalShopperStoreEmail;
            }

        }

    }

    const params = {
        document: {
            service: "ebmtrigger1",
            cookie: "test",
            request: {
                eid: formConfig ? formConfig.eid : '',
                email: email,
                CONTACTINFO: payload
            }
        }
    };

    const route = {
        method: 'POST',
        path: path,
        entity: params
    };

    yield call(makeRequest, route);
}

export function formatPayload(formData) {
    const payload = {};

    _.forEach(formData, (data) => {
        // Stringify the values to escape special characters but then strip the wrapping quotes
        payload[data.name.toUpperCase()] = JSON.stringify(data.value).replace(/\"/g, '');
    });

    return payload;
}
